import React from 'react';
import { useTranslation } from 'react-i18next';

import { Notification } from '@swyftx/aviary/atoms/Notification';
import { Body } from '@swyftx/aviary/atoms/Typography';

import { cn } from '@shared/utils/lib/ui';

import { useMarginPrices } from 'src/lib/margin/hooks/prices';

type Props = {
  className?: string;
  containerClassName?: string;
};

const SwyftxMarginStalePriceBanner: React.FC<Props> = ({ containerClassName, className }) => {
  const { t } = useTranslation('margin');
  const { isStalePriceData } = useMarginPrices();

  if (!isStalePriceData()) return null;

  return (
    <div className={containerClassName}>
      <Notification severity='warning' className={cn('w-full', className)}>
        <Body size='small' className='mt-4'>
          {t('stalePrice.banner.content')}
        </Body>
      </Notification>
    </div>
  );
};

export { SwyftxMarginStalePriceBanner };
